module.exports = __webpack_public_path__ + "img/icon7.d2700af0.svg";